import type { Step } from '@/types'

/** Objective-specific steps: Cellulite (celulite) */
export const celluliteSteps: Step[] = []
